export const formatData = [{ name: "Export de données (xlsx)", id: 'xlsx' }, { name: "Rapport avec template (docx)", id: 'docx' }]
export const formatDatase60 = [{ name: "Export de données (xlsx)", id: 'xlsx' }, { name: "Rapport avec template (docx)", id: 'docx' }, { name: "Rapport avec template SE60 (docx)", id: 'se60docx' }]
export const typeData = [{ name: "Ponctuel", id: 0 }, { name: "Récurrent", id: 1 }]
export const recurrenceData = [{ name: "Tous les jours", id: "1D" },
{ name: "Toutes les semaines", id: "1W" },
{ name: "Tous les mois", id: "1M" },
{ name: "Tous les ans", id: "1Y" }]
export const periodData = [{ name: "La veille", id: "yest" },
{ name: "La semaine passée", id: "lastweek" },
{ name: "Le mois passé", id: "lastmonth" },
{ name: "Le mois en cours", id: "currentmonth" },
{ name: "L'année passée", id: "lastyear" },
{ name: "L'année en cours", id: "currentyear" },
{ name: "1 année glissante", id: "oneyear" },
{ name: "Choix des dates", id: "datechoice" },
]
export const duplicateData = [{ name: "Juste le groupe selectionné", id: "no" },
{ name: "Le groupe et toutes les communes", id: "groupetown" },
{ name: "Le groupe et tous les EPCI", id: "groupeepci" },
{ name: "Le groupe et tous les sites", id: "groupesite" },
{ name: "Le groupe et tous les bâtiments", id: "groupebat" },
{ name: "Le groupe et tous les équipements urbains", id: "groupeequrb" },
{ name: "Le groupe et toutes les zones", id: "groupezone" },
{ name: "Toutes les communes", id: "town" },
{ name: "Tous les EPCI", id: "epci" },
{ name: "Tous les sites", id: "site" },
{ name: "Tous les bâtiments", id: "bat" },
{ name: "Tous les équipements urbains", id: "equrb" },
{ name: "Toutes les zones", id: "zone" },
]
export const templateIndicSize = [{ name: "25%", id: "25" },
{ name: "50%", id: "50" },
{ name: "75%", id: "75" },
{ name: "100%", id: "100" }]
export const paramTypeDataTemplate = [{ name: "Graphique", id: "indic" },
{ name: "Patrimoine", id: "patrimoine" },
{ name: "Plan d'action", id: "actionplan" },
{ name: "Alertes", id: "alert" },
{ name: "Carte", id: "maps" },
{ name: "Evènements", id: "event" },
{ name: "Evènements avec détail", id: "eventdetailed" }]
export const paramTypeDataExport = [{ name: "Graphique", id: "indic" },
{ name: "Patrimoine", id: "patrimoine" },
{ name: "Plan d'action", id: "actionplan" },
{ name: "Alertes", id: "alert" },
{ name: "Optimisation du TURPE", id: "turpe" },
{ name: "Evènements", id: "event" },
{ name: "Evènements avec détail", id: "eventdetailed" },
{ name: "Dashboard utilisateurs", id: "userdashboard" },
]

export const paramTypeIndicPeriod = [{ name: "Identique au rapport", id: "same" },
{ name: "La veille", id: "yest" },
{ name: "La semaine passée", id: "lastweek" },
{ name: "Le mois passé", id: "lastmonth" },
{ name: "Le mois en cours", id: "currentmonth" },
{ name: "L'année passée", id: "lastyear" },
{ name: "L'année en cours", id: "currentyear" },
{ name: "1 année glissante", id: "oneyear" },
{ name: "Choix des dates", id: "datechoice" },]

export const paramTypeAlertValueData = [{ name: "Information", id: "criticity_0" },
{ name: "Avertissement", id: "criticity_1" },
{ name: "Important", id: "criticity_2" },
{ name: "Critique", id: "criticity_3" }]

export const paramTypeIndicValueData = [{ name: "Top des consommations électriques par site", id: "0" },
{ name: "Synthèse des consommations annuelles électriques par groupe", id: "1" },
{ name: "Répartition des consommations par période tarifaire", id: "2" },
{ name: "Comparaison des consommations mensuelles d'électricité", id: "3" },
{ name: "Facturation Electricité HTVA", id: "4" },
{ name: "Répartition facture Electricité", id: "5" },
{ name: "Tableau facturation électricité mensuel", id: "6" },
{ name: "Suivi mensuel des taux", id: "7" },
{ name: "Suivi des taux par site", id: "8" }]

export const paramTypePatrimoineValueData = [
{ name: "Sites : Paramètres généraux", id: "1.0_key_parameters" },
{ name: "Bâtiments : Paramètres généraux", id: "2.0_key_parameters" },
{ name: "Equipements urbains : Paramètres généraux", id: "2.1_key_parameters" },
{ name: "Zones : Paramètres généraux", id: "3.0_key_parameters" },
{ name: "Groupes : Paramètres généraux", id: "0.all_key_parameters" },
{ name: "Compte : Liste des compteurs électricité", id: "4.0_accountmeters_electricity" },
{ name: "Compte : Liste des compteurs gaz", id: "4.0_accountmeters_gas" },
{ name: "Compte : Liste des compteurs eau", id: "4.0_accountmeters_water" },
{ name: "Compte : Liste des compteurs chaleur", id: "4.0_accountmeters_heat" },
{ name: "Compte : Liste des compteurs froid", id: "4.0_accountmeters_cold" },
{ name: "Compte : Liste des compteurs propane", id: "4.0_accountmeters_propane" },
{ name: "Compte : Liste des compteurs fioul", id: "4.0_accountmeters_fuel" },
{ name: "Compte : Liste des compteurs bois", id: "4.0_accountmeters_wood" },
{ name: "Tous : Liste des compteurs attribués", id: "All_meters_allmeters" },
{ name: "Bâtiments et zones : Liste des parois", id: "2.0-3.0_walls_walls" },
{ name: "Tous : Liste des équipements", id: "All_equipments_equipments" },
{ name: "Compte : Liste des compteurs électricité (mandat)", id: "4.0_accountmetersmandat_electricity" },
{ name: "Compte : Liste des compteurs gaz (mandat)", id: "4.0_accountmetersmandat_gas" },
{ name: "Compte : Liste des compteurs eau (mandat)", id: "4.0_accountmetersmandat_water" },
{ name: "Compte : Liste des compteurs chaleur (mandat)", id: "4.0_accountmetersmandat_heat" },
{ name: "Compte : Liste des compteurs froid (mandat)", id: "4.0_accountmetersmandat_cold" },
{ name: "Compte : Liste des compteurs propane (mandat)", id: "4.0_accountmetersmandat_propane" },
{ name: "Compte : Liste des compteurs fioul (mandat)", id: "4.0_accountmetersmandat_fuel" },
{ name: "Compte : Liste des compteurs bois (mandat)", id: "4.0_accountmetersmandat_wood" },
]

export const paramTypeMapsValueData = [
    { name: "Sites : Top 10 des consommations électricité", id: "1.0_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_ELEC },
    { name: "Bâtiments : Top 10 des consommations électricité", id: "2.0_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_ELEC },
    { name: "Equipements urbains : Top 10 des consommations électricité", id: "2.1_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_ELEC },
    { name: "Sites : Top 10 des consommations gaz", id: "1.0_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_GAS },
    { name: "Bâtiments : Top 10 des consommations gaz", id: "2.0_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_GAS },
    { name: "Equipements urbains : Top 10 des consommations gaz", id: "2.1_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_GAS },
    { name: "Sites : Top 10 des consommations eau", id: "1.0_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_WATER },
    { name: "Bâtiments : Top 10 des consommations eau", id: "2.0_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_WATER },
    { name: "Equipements urbains : Top 10 des consommations eau", id: "2.1_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_WATER },
    { name: "Sites : Top 10 des consommations autres", id: "1.0_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_OTHER },
    { name: "Bâtiments : Top 10 des consommations autres", id: "2.0_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_OTHER },
    { name: "Equipements urbains : Top 10 des consommations autres", id: "2.1_"+process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_OTHER },
    ]

    export const paramTypeActionPlanValueData = [
        { name: "Etats des plans d'actions", id: "actionplan_state" },
        { name: "Liste des actions en retard", id: "action_late" },
        { name: "Liste des actions finies", id: "action_finished" },
        { name: "Liste de toutes les actions", id: "action_all" },
        { name: "Somme des actions par catégories", id: "action_categorysum" },
        { name: "Somme des actions par type d'ENR", id: "action_enrsum" },
        { name: "Somme des actions par scénarios", id: "action_sceneriosum" },
    ]